// extracted by mini-css-extract-plugin
export default {"box":"RemoveTags_box__+R-Ir","selectTitle":"RemoveTags_selectTitle__Q9dMb","title":"RemoveTags_title__Sjhm3","inputTitle":"RemoveTags_inputTitle__Ru1Qw"};